import { defineComponent as g, computed as x, unref as r, reactive as k, toRefs as y, getCurrentInstance as D, onBeforeUnmount as I, nextTick as S } from "vue";
import { useOption as _ } from "./index792.js";
import { optionProps as E, COMPONENT_NAME as p } from "./index793.js";
import { useNamespace as M } from "./index559.js";
import { useId as P } from "./index640.js";
var L = g({
  name: p,
  componentName: p,
  props: E,
  setup(l) {
    const o = M("select"), d = P(), m = x(() => [
      o.be("dropdown", "item"),
      o.is("disabled", r(n)),
      o.is("selected", r(c)),
      o.is("hovering", r(a))
    ]), s = k({
      index: -1,
      groupDisabled: !1,
      visible: !0,
      hover: !1
    }), {
      currentLabel: u,
      itemSelected: c,
      isDisabled: n,
      select: e,
      hoverItem: f,
      updateOption: v
    } = _(l, s), { visible: O, hover: a } = y(s), t = D().proxy;
    e.onOptionCreate(t), I(() => {
      const i = t.value;
      S(() => {
        const { selected: h } = e.states, C = h.some((N) => N.value === t.value);
        e.states.cachedOptions.get(i) === t && !C && e.states.cachedOptions.delete(i);
      }), e.onOptionDestroy(i, t);
    });
    function b() {
      n.value || e.handleOptionSelect(t);
    }
    return {
      ns: o,
      id: d,
      containerKls: m,
      currentLabel: u,
      itemSelected: c,
      isDisabled: n,
      select: e,
      visible: O,
      hover: a,
      states: s,
      hoverItem: f,
      updateOption: v,
      selectOptionClick: b
    };
  }
});
export {
  L as default
};
